export default __webpack_public_path__ + "static/simple-histogram-eadef19cb39b02cd61c268033804e148.png";